import { observer } from 'mobx-react';
import * as React from 'react';
import LearningCollectionEditStore from '../../../../Store';
import { ModifiableExperiencesContext } from '../../../../../Types';
import CustomizeRow from './CustomizeRow';

interface Props {
  context: ModifiableExperiencesContext;
  learningCollectionStore: LearningCollectionEditStore;
}

const DeletedExperiences: React.FC<Props> = ({ context, learningCollectionStore }) =>
  learningCollectionStore.deletedExperienceStores(context).map(({ experienceResource }) => (
    <tr
      className="inline-block align-top first:pt-4 [&:not(:last-child)]:pb-4"
      key={experienceResource.payload.id}
    >
      <CustomizeRow
        context={context}
        experienceResource={experienceResource}
        learningCollectionStore={learningCollectionStore}
      />
    </tr>
  ));

export default observer(DeletedExperiences);
